<div class="kvkk-wrapper">

  <mat-horizontal-stepper linear #stepper>

    <!-- STEP 1 -->
    <mat-step [stepControl]="kvkkForm">
      <form [formGroup]="kvkkForm">

        <ng-template matStepLabel>KVKK Aydınlatma</ng-template>

        <iframe type="application/pdf" width="100%" height="400px"
          src="https://akilliyoklama.ankara.edu.tr/yoklamaklavuz/kvkk_sozlesme/kvkk.pdf#toolbar=0&navpanes=0&scrollbar=0">
        </iframe>

        <mat-checkbox formControlName="read">
          Okudum ve anladım
        </mat-checkbox>

        <div class="actions">
          <button mat-raised-button color="primary" matStepperNext [disabled]="!kvkkForm.valid">
            Devam
          </button>
        </div>

      </form>
    </mat-step>

    <!-- STEP 2 -->
    <mat-step [stepControl]="agreementForm">
      <form [formGroup]="agreementForm">

        <ng-template matStepLabel>Kullanıcı Sözleşmesi</ng-template>


        <iframe width="100%" height="400px" src="https://akilliyoklama.ankara.edu.tr/yoklamaklavuz/kvkk_sozlesme/sozlesme.pdf#toolbar=0&navpanes=0&scrollbar=0">
        </iframe>



        <mat-checkbox formControlName="accepted">
          Kullanıcı sözleşmesini kabul ediyorum
        </mat-checkbox>

        <div class="actions">
          <button mat-button matStepperPrevious>Geri</button>

          <button mat-raised-button color="primary" matStepperNext [disabled]="!agreementForm.valid">
            Devam
          </button>
        </div>

      </form>
    </mat-step>

    <!-- STEP 3 -->
    <mat-step [stepControl]="consentForm">
      <form [formGroup]="consentForm">

        <ng-template matStepLabel>Açık Rıza</ng-template>

        <p>Akıllı Yoklama Sistemi kapsamında, yoklama doğrulama işleminin <br>
          gerçekleştirilebilmesi amacıyla konum verilerimin işlenmesine, <br>
          özgür irademle ve bilgilendirilmiş olarak açık rıza verdiğimi kabul ediyorum.<br>
          Rıza vermemem halinde alternatif yoklama yöntemlerinin tarafıma sunulacağını biliyorum.</p>

        <mat-slide-toggle formControlName="consent">
          Açık rıza veriyorum
        </mat-slide-toggle>

        <div class="actions">
          <button mat-button matStepperPrevious>Geri</button>

          <button mat-raised-button color="primary" (click)="completeFlow()" [disabled]="!consentForm.valid">
            Tamamla
          </button>
        </div>

      </form>
    </mat-step>

  </mat-horizontal-stepper>

</div>
